import api from '../../api/index.js'

const state = {
    MemorialHallSearchApiModelList:[],
    vMemorialHallDetailed:null,

}

const getters = {
    vMemorialHallDetailed:state=>{
        return state.vMemorialHallDetailed;
    }
}

const actions = {
    // 获取广场里的纪念馆,根据ReadShowType: 来区别
    // {commit},
    GetMemorialHallSearch({commit},payload) {
        return new Promise((resolve, reject) => {
            api.get('/MemorialHall/MemorialHallSearch',payload, res => {                
                commit({
                    type: "setMemorialHallList",
                    res: res.Result,
                });
                resolve(res.Result);
            }, err => {
                reject(err);
            })
        })
    },
    // 获取纪念馆权限
    getIsSelfMemorialHall({commit},payload){
        return new Promise((resolve, reject) => {
            api.get('/MemorialHall/IsSelfMemorialHall',payload, res => {                
                resolve(res.Result);
            }, err => {
                reject(err);
            })
        })
    },
    GetMemorialHallSearchApiById({commit},payload){
        return new Promise((resolve, reject) => {
            api.get('/MemorialHall/GetMemorialHallSearchApiById',payload, res => {   
                commit({
                    type: "setViewMemorialHall",
                    res: res.Result,
                })             
                resolve(res.Result);
            }, err => {
                reject(err);
            })
        })
    },
    
    // 点击关注
    addFollowMemorialHallVue({commit},payload){
        return new Promise((resolve,reject) => {
            api.post('/MemorialHall/FollowMemorialHallVue',payload, res => {
                resolve(res.Result)
            }, err => {
                reject(err)
            }) 
        });
    },
    MemorialHallIsPublic({commit},payload){
        return new Promise((resolve,reject) => {
            api.get('/MemorialHall/IsPublic',payload, res => {
                resolve(res.Result)
            }, err => {
                reject(err)
            }) 
        });
    },
    MemorialHallIsFriend({commit},payload){
        return new Promise((resolve,reject) => {
            api.get('/MemorialHall/IsFriend',payload, res => {
                resolve(res.Result)
            }, err => {
                reject(err)
            }) 
        });
    },
    MemorialHallValidate({commit},payload){
        return new Promise((resolve,reject) => {
            api.post('/MemorialHall/MemorialHallValidate',payload, res => {
                resolve(res.Result)
            }, err => {
                reject(err)
            }) 
        });
    }
    
}

const mutations = {
    setMemorialHallList(state, payload) {
        state.MemorialHallSearchApiModelList = payload.res.MemorialHallSearchApiModelList;
    },
    setViewMemorialHall(state, payload){
        state.vMemorialHallDetailed = payload.res;
    }
}

export default {
    state,
    getters,
    actions,
    mutations
}
